/** @jsxImportSource @emotion/react */
import _ from "lodash";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { services } from "../../../services";
import { EditComponent, ScaffoldMain, useAlertListener } from "../../../ui";

import * as styles from "./styles";

export const BlogEdit = () => {
  const params = useParams();
  const { addAlert } = useAlertListener();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [initForm, setInitForm] = useState({
    "title-spanish": "",
    "subtitle-spanish": "",
    "content-spanish": "",
    "subtitle-english": "",
    "title-english": "",
    "content-english": "",
    createdBy: "",
    image: null as any,
  });

  const inputs = [
    {
      type: "subtitle",
      label: "Español",
    },
    {
      type: "text",
      placeholder: "Escribir título",
      label: "Título",
      name: "title-spanish",
    },
    {
      type: "text",
      placeholder: "Escribir subtítulo",
      label: "Subtítulo",
      name: "subtitle-spanish",
    },
    {
      type: "textarea-advance",
      placeholder: "Escribir contenido",
      label: "Contenido",
      name: "content-spanish",
    },
    {
      type: "space",
      value: "sm",
    },
    {
      type: "subtitle",
      label: "Ingles",
    },
    {
      type: "text",
      placeholder: "Escribir título",
      label: "Título",
      name: "title-english",
    },
    {
      type: "text",
      placeholder: "Escribir subtítulo",
      label: "Subtítulo",
      name: "subtitle-english",
    },
    {
      type: "textarea-advance",
      placeholder: "Escribir contenido",
      label: "Contenido",
      name: "content-english",
    },
    {
      type: "space",
      value: "sm",
    },
    {
      type: "subtitle",
      label: "Más información",
    },
    {
      type: "text",
      placeholder: "Escribir autor",
      label: "Autor",
      name: "createdBy",
    },
    {
      type: "file",
      placeholder: "Seleccionar imagen",
      label: "Imagen",
      name: "image",
    },
  ];

  useEffect(() => {
    getNew();
  }, []);

  const getNew = async () => {
    try {
      setLoading(true);
      const resp = await services.blogShow(params.id || "");

      if (resp?.data?.body) {
        setInitForm({
          ..._.pick(resp.data.body.blog, [
            "title-spanish",
            "subtitle-spanish",
            "content-spanish",
            "subtitle-english",
            "title-english",
            "content-english",
            "createdBy",
          ]),
          image: services.blogImageDownload(resp.data.body.blog["image"]),
        });
      } else {
        navigate(-1);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      addAlert({
        title: "Hubo un problema, intentarlo más tarde.",
        type: "alert",
      });
    }
  };

  const onReturn = async () => {
    navigate(-1);
  };

  const navigateSuccess = async () => {
    navigate("/blog", { replace: true });
  };

  const navigateDestroy = async () => {
    navigate("/blog", { replace: true });
  };

  return (
    <ScaffoldMain
      root="blog"
      title="Editar blog"
      onReturn={onReturn}
      destroy={{
        id: params.id || "",
        serviceDestroy: services.blogDestroy,
        navigateDestroy,
      }}
    >
      <EditComponent
        initLoading={loading}
        initForm={initForm}
        inputs={inputs}
        service={(payload: any) =>
          services.blogUpdate(params.id || "", {
            ...payload,
            image:
              typeof payload.image === "string"
                ? params.id
                : typeof payload.image === "object"
                ? payload.image
                : null,
          })
        }
        navigateSuccess={navigateSuccess}
        isEdit
      />
    </ScaffoldMain>
  );
};
